<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-form ref="query" :model="query" inline>
        <el-form-item prop="isProhibit" label="显示停产产品">
          <el-checkbox v-model="query.isProhibit" size="small" />
        </el-form-item>
        <el-form-item prop="fStockID" label="仓库">
          <el-select
            v-model="query.fStockID"
            style="width: 200px"
            size="small"
            clearable
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in stockList"
              :key="item.fStockID"
              :value="item.fStockID"
              :label="item.fName"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="产品">
          <el-select-table
            v-model="fICItemID"
            :label.sync="ficItemName"
            url="ICItemManage/ICItem/ChoiceICItemEntry"
            label-field="fName"
            value-field="ficItemID"
            size="small"
            :extra-param="{ prohibit: false }"
            panel-width="500px"
            :clearable="false"
            :columns="[
              { prop: 'fNumber', label: '编码' },
              { prop: 'fName', label: '名称' },
              { prop: 'fModel', label: '规格' },
              { prop: 'fUnit', label: '单位' },
            ]"
            @change="fNumber_cpChange"
          />
        </el-form-item>
        <el-form-item prop="fBatchNo" label="批号">
          <el-input v-model="query.fBatchNo" size="small" />
        </el-form-item>
        <el-form-item prop="fRetroactiveNo" label="追溯号">
          <el-input v-model="query.fRetroactiveNo" size="small" />
        </el-form-item>
      </el-form>

      <el-button
        type="primary"
        size="small"
        style="margin-right: 10px"
        @click="refresh"
      >查询</el-button>
      <el-button-export
        v-if="candown"
        :url="downloadUrl"
        type="primary"
        size="small"
      >下载报表</el-button-export>
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
      >
        <el-table-column>
          <template slot-scope="scope">
            <el-button
              v-if="canlook&&scope.row.fInventoryID!==0"
              type="text"
              size="small"
              @click="lockClick(scope.row)"
            >锁库</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="fNumber" label="产品编码" width="150" />
        <el-table-column prop="fName" label="产品名称" width="150" />
        <el-table-column prop="fModel" label="规格" width="150" />
        <el-table-column prop="fUnit" label="单位" />
        <el-table-column prop="fStock" label="仓库" />
        <el-table-column prop="fQty" label="库存数" />
        <el-table-column prop="fLockQty" label="锁库数" />
        <el-table-column prop="fDate_Sc" label="生产日期" width="100" />
        <el-table-column prop="fBatchNo" label="批号" width="150" />

        <el-table-column prop="fDate_Xd" label="消毒日期" width="100" />
        <el-table-column prop="fRetroactiveNo" label="追溯号" width="150" />
        <el-table-column prop="fLockDes" label="锁库说明" width="150" />
        <el-table-column prop="fDate" label="库存日期" width="100" />
      </el-table>
    </div>
    <div>
      <el-pagination
        :current-page.sync="query.pageIndex"
        :page-size.sync="query.pageSize"
        :page-sizes="[20, 50, 100, 500]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageRecordTotal"
        @size-change="refresh"
        @current-change="refresh"
      />
    </div>
  </div>
</template>
<script>
import EditForm from './EditForm'

export default {
  components: {
    EditForm
  },
  data() {
    return {
      query: {
        isProhibit: false,
        fStockID: null,
        fBatchNo: null,
        fRetroactiveNo: null,
        fICItemID: null,

        pageIndex: 1,
        pageSize: 20
      },
      fICItemID: null,
      ficItemName: null,
      pageRecordTotal: 0,
      stockList: [],
      ICItemList: [],
      tableData: [],
      loading: false,
      currentEditItem: null,
      canlook: true,
      candown: true,
      ts: null
    }
  },
  watch: {
    ficItemName: {
      handler(val, old) {
        // console.log(val, 'val')
        if (val == null) {
          this.fICItemID = null
        }
      }
    }

  },
  activated() {},
  mounted() {
    if (this.ts !== this.$route.query.ts) {
      this.refresh()
    }
    this.getStockEntry()
    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants
    // console.log(userGrants,'userGrants')
    userGrants.forEach((val) => {
      if (val.key == '006007003') {
        this.canlook = val.isGrant
      }
      if (val.key == '006007002') {
        this.candown = val.isGrant
      }
    })
  },
  beforeRouteEnter(to, from, next) {
    // console.log(next, "next");
    next((vm) => {
      if (vm.ts == vm.$route.query.ts) {
        // 跳转过来时
      } else {
        vm.refresh()
        // vm.fICItemID = vm.$route.query.fICItemID;
        // vm.ts = vm.$route.query.ts;
      }
    })
  },
  methods: {
    refresh() {
      console.log(this.$route.query, 'this.$route.query')
      if (this.ts == this.$route.query.ts) {
        this.query.fICItemID = this.fICItemID
      } else {
        this.query.fICItemID = this.$route.query.items.ficItemID
        // this.query.fStockID = this.$route.query.items.fStockID
        this.fICItemID = this.$route.query.items.ficItemID
        this.ficItemName = this.$route.query.items.fName
        this.ts = this.$route.query.ts
      }
      this.loading = true
      this.$httpPost('Report/InventoryEntry', this.query)
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message)
            return
          }
          this.tableData = res.datalist.dataEntry
          this.pageRecordTotal = res.datalist.total
        })
        .finally(() => (this.loading = false))
    },
    fNumber_cpChange: function(item) {
      console.log(item, 'item1')
    },
    input_cpChange(item) {
      console.log(item, 'item12')
    },
    getStockEntry() {
      this.$httpPost('Warehouse/Stock/StockEntry', {}).then((res) => {
        if (!res.isSuccess) {
          this.$message.error(res.message)
          return
        }
        this.stockList = res.datalist
      })
    },

    lockClick: function(row) {
      this.currentEditItem = Object.assign({}, row)
      const h = this.$createElement
      this.$formDlg({
        title: '锁库',
        width: '30%',
        formTpl: <EditForm form={this.currentEditItem}></EditForm>,
        formSubmit: (formData) => this.postData(formData)
      })
    },
    postData(formData) {
      this.$httpPost('Report/InventoryLockQty', {
        fInventoryID: formData.fInventoryID,
        fLockQty: formData.fLockQty,
        fLockDes: formData.fLockDes
      }).then((res) => {
        // console.log(res);
        if (!res.isSuccess) {
          this.$message.error(res.message)
          throw res.message
        } else {
          this.$message.success(res.message)
          this.refresh()
        }
      })
    },
    downloadUrl: function() {
      var req = this.query
      delete req.pageIndex
      delete req.pageSize
      return this.$buildDownloadUrl(
        'LogisticsSystemApi/Report/InventoryEntryDownload',
        this.queryParam(true)
      )
    },
    queryParam: function(forExport) {
      var rtn = {
        ...this.query
      }
      if (forExport) {
        delete rtn.pageIndex
        delete rtn.pageSize
      }
      return rtn
    }
  }
}
</script>
<style scoped lang='less'>
.query-bar {
}
</style>
